import { render, staticRenderFns } from "./InspectionVideoWatchStatusBadge.vue?vue&type=template&id=5289e662&scoped=true"
import script from "./InspectionVideoWatchStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionVideoWatchStatusBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionVideoWatchStatusBadge.vue?vue&type=style&index=0&id=5289e662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5289e662",
  null
  
)

export default component.exports